module.exports = __webpack_public_path__ + "img/智能客服图片.33c45e95.png";